import { Component, Input } from '@angular/core';
import { AppConfigService } from '@services/app-config.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { NotificationManager } from '@managers/notification.manager';

@Component({
    selector: 'lex-prompt-response',
    templateUrl: './prompt-response.component.html',
    styleUrl: './prompt-response.component.scss',
    standalone: false
})
export class PromptResponseComponent {
	@Input() responseText: string | string[];
	@Input() isLoading: boolean;

	constructor(private clipboard: Clipboard,
		private appConfigService: AppConfigService,
		private notificationManager: NotificationManager) {
	}

	public getResponseText(): string {
		if (Array.isArray(this.responseText)) {
			return this.responseText.join('\n\n');
		}
		return this.responseText as string;
	}

	public copyResponseToClipboard(): void {
		const response = this.getResponseText();
		this.clipboard.copy(response
			.replaceAll('" target="DocViewer">link</a>]', '] ')
			.replaceAll('<a href="/review/doc-viewer?', `${this.appConfigService.getConfig().webApi}/review/doc-viewer?`));
		this.notificationManager.displaySnackBarMessage({
			message: 'Response copied to clipboard!'
		});
	}

}
